export default __webpack_public_path__ + "static/10.03-6-b41851c6d921a2b0cb7057bc0c1624cf.png";